import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';

import { LoginService } from '../login/shared/login.service';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css']
})
export class UnauthorizedComponent implements OnInit, AfterViewInit {
  constructor(
    // private authService: AuthenticationService,
    private loginService: LoginService,
    private router: Router
  ) { }

  ngOnInit() { console.log('welcome to unauthorize page.') }

  ngAfterViewInit() {
    this.checkPermission();
  }

  checkPermission() {
    this.loginService.validateToken().subscribe(
      res => {
        console.log(res)
        if (res.data) {
          this.router.navigate(['/']);
        }

        if (res.message == '403') {
          // do nothing...
          return;
        } else {
          this.router.navigate(['/']);
        }
        
      }

    )
  }

}
